"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetRelatedContentBySvodProvider = exports.GetLatestFromSvodProvider = exports.GetSVODDataSearch = exports.GetContentSearch = exports.GetForChannel = exports.GetMappingsStats = exports.GetDiscoverableMappings = exports.GetDiscoverableMappingsCount = exports.GetMappings = exports.GetMappingsCount = exports.GetMappingsById = exports.GetMappingsByMetabroadcastId = exports.GetHealthCheckSystem = exports.GetHealthCheck = exports.GetDataDictionaryCategories = exports.GetDataDictionarySVODProviders = exports.GetDataDictionaryGenres = exports.GetContentBroadcastsById = exports.GetContentById = exports.GetTVProviders = exports.GetRegions = exports.GetChannelById = exports.GetChannelsByGroupId = exports.GetChannelGroups = void 0;
// This file is auto-generated, do not modify directly!
var GetChannelGroups = {
  endpoint: '/channel/groups',
  method: 'get'
};
exports.GetChannelGroups = GetChannelGroups;
var GetChannelsByGroupId = {
  endpoint: '/channel/group/{id}',
  method: 'get'
};
exports.GetChannelsByGroupId = GetChannelsByGroupId;
var GetChannelById = {
  endpoint: '/channel/{id}',
  method: 'get'
};
exports.GetChannelById = GetChannelById;
var GetRegions = {
  endpoint: '/channel/regions/{network}',
  method: 'get'
};
exports.GetRegions = GetRegions;
var GetTVProviders = {
  endpoint: '/channel/providers',
  method: 'get'
};
exports.GetTVProviders = GetTVProviders;
var GetContentById = {
  endpoint: '/content/{id}',
  method: 'get'
};
exports.GetContentById = GetContentById;
var GetContentBroadcastsById = {
  endpoint: '/content/{id}/broadcasts',
  method: 'get'
};
exports.GetContentBroadcastsById = GetContentBroadcastsById;
var GetDataDictionaryGenres = {
  endpoint: '/data-dictionary/genres',
  method: 'get'
};
exports.GetDataDictionaryGenres = GetDataDictionaryGenres;
var GetDataDictionarySVODProviders = {
  endpoint: '/data-dictionary/svod-providers',
  method: 'get'
};
exports.GetDataDictionarySVODProviders = GetDataDictionarySVODProviders;
var GetDataDictionaryCategories = {
  endpoint: '/data-dictionary/categories',
  method: 'get'
};
exports.GetDataDictionaryCategories = GetDataDictionaryCategories;
var GetHealthCheck = {
  endpoint: '/healthcheck',
  method: 'get'
};
exports.GetHealthCheck = GetHealthCheck;
var GetHealthCheckSystem = {
  endpoint: '/healthcheck/system',
  method: 'get'
};
exports.GetHealthCheckSystem = GetHealthCheckSystem;
var GetMappingsByMetabroadcastId = {
  endpoint: '/mappings/by-metabroadcast-id/{mbId}',
  method: 'get'
};
exports.GetMappingsByMetabroadcastId = GetMappingsByMetabroadcastId;
var GetMappingsById = {
  endpoint: '/mappings/{id}/repid',
  method: 'get'
};
exports.GetMappingsById = GetMappingsById;
var GetMappingsCount = {
  endpoint: '/mappings/count',
  method: 'get'
};
exports.GetMappingsCount = GetMappingsCount;
var GetMappings = {
  endpoint: '/mappings',
  method: 'get'
};
exports.GetMappings = GetMappings;
var GetDiscoverableMappingsCount = {
  endpoint: '/mappings/discoverable/count',
  method: 'get'
};
exports.GetDiscoverableMappingsCount = GetDiscoverableMappingsCount;
var GetDiscoverableMappings = {
  endpoint: '/mappings/discoverable',
  method: 'get'
};
exports.GetDiscoverableMappings = GetDiscoverableMappings;
var GetMappingsStats = {
  endpoint: '/mappings/stats',
  method: 'get'
};
exports.GetMappingsStats = GetMappingsStats;
var GetForChannel = {
  endpoint: '/channels/{channelId}/schedule',
  method: 'get'
};
exports.GetForChannel = GetForChannel;
var GetContentSearch = {
  endpoint: '/content/search',
  method: 'get'
};
exports.GetContentSearch = GetContentSearch;
var GetSVODDataSearch = {
  endpoint: '/content/search/svod',
  method: 'get'
};
exports.GetSVODDataSearch = GetSVODDataSearch;
var GetLatestFromSvodProvider = {
  endpoint: '/svod/{provider}/latest',
  method: 'get'
};
exports.GetLatestFromSvodProvider = GetLatestFromSvodProvider;
var GetRelatedContentBySvodProvider = {
  endpoint: '/svod/content/{id}/related/by-provider',
  method: 'get'
};
exports.GetRelatedContentBySvodProvider = GetRelatedContentBySvodProvider;